import React from "react";
import Euro1 from "../../assets/images/euro1.svg";
import Euro2 from "../../assets/images/euro2.svg";
import Hand from "../../assets/images/mano.svg";
import Shadow from "../../assets/images/ombra.svg";

export const Loading = ({ customClasses }) => {
  return (
    <figure className={["loading-anim", customClasses].join(" ")}>
      <img id="euro_1" src={Euro1} alt="Euro coin in movement" />
      <img id="euro_2" src={Euro2} alt="Euro coin in movement" />
      <img id="hand" src={Hand} alt="Hand juggling euro coins" />
      <img id="shadow" src={Shadow} alt="Shadow under the hand" />
    </figure>
  );
};
